import React, { useState, useEffect } from "react";
import {
  DataGrid,
  GridActionsCellItem,
  GridDeleteIcon,
  GridToolbar,
} from "@mui/x-data-grid";
import ConfirmationModal from "../confirmation-modal/ConfirmationModal";
import SuccessAlert from "../success-alert/SuccessAlert";
import ErrorAlert from "../error-alert/ErrorAlert";
import { API, SERVER_DOMAIN } from "../../assets/staticData";
import EditIcon from "@mui/icons-material/Edit";
import EditArticle from "../editors/EditArticle";
import EditUser from "../editors/EditUser";
import usePermission from "../../hooks/use-permission";
import LockResetIcon from '@mui/icons-material/LockReset';
import ChangePasswordModal from "../editors/ChangePasswordModal";

export default function UsersDataTable({
  data,
  endpoint,
  setRefresh,
  refresh,
  user
}) {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(undefined);
  const [confirmed2, setConfirmed2] = useState(false);
  const [clickedEntryId, setClickedEntryId] = useState();
  const [selected, setSelected] = useState([]);
  const [deleteSelected, setDeleteSelected] = useState(false);
  const [item, setItem] = useState({});

  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);

  const { hasPermission } = usePermission()

  let token = process.env.REACT_APP_ADMIN_TOKEN;

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "image",
      headerName: "Image",
      width: 100,
      renderCell: (params) => (
        <img
          src={params.value}
          style={{
            height: "74%",
            aspectRatio: 1,
            borderRadius: 25,
            marginTop: "6%",
            objectFit: "cover",
          }}
        />
      ),
    },
    { field: "username", headerName: "Name", width: 170 },
    { field: "position", headerName: "Position", width: 150 },
    {
      field: "date",
      headerName: "Date",
      width: 130,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      cellClassName: "actions",
      width: 130,
      getActions: ({ id }) => {
        return [
          hasPermission(
            "Admin",
            "edit"
          )
            ? <GridActionsCellItem
              icon={<EditIcon />}
              label="Edit"
              onClick={() => setItem({ id })}
            />
            : <></>,

          hasPermission(
            "Admin",
            "delete"
          )
            ? <GridActionsCellItem
              icon={<GridDeleteIcon />}
              label="Delete"
              onClick={handleDeleteClick(id)}
            />
            : <></>,
          hasPermission("Admin", "set-password")
            ? (
              <GridActionsCellItem
                icon={<LockResetIcon />}
                label="Set Password"
                onClick={showChangePasswordForm.bind(this, id)}
              />
            )
            : <></>
        ];
      },
    },
  ];

  const handleDeleteClick = (id) => () => {
    setOpen(true);
    setClickedEntryId(id);
  };

  useEffect(() => {
    async function deleteEntry() {
      if (confirmed == true) {
        fetch(`${API}/${endpoint}/${clickedEntryId}`, {
          headers,
          method: "DELETE",
        }).then(async (res) => {
          if (res.ok) {
            setSuccess(true);
            setRows(rows.filter((row) => row.id !== clickedEntryId));
            setConfirmed(false);
          } else {
            setFail(true);
            setConfirmed(false);
          }
        });
      }
    }

    deleteEntry();
  }, [confirmed]);

  const showChangePasswordForm = (id) => {
    setOpenChangePassword(true)
    setSelectedUserId(id)
  };

  const closeChangePasswordForm = () => {
    setOpenChangePassword(false)
    setSelectedUserId(undefined)
  };

  useEffect(() => {
    let docs = [];
    let checksDocs = [];
    data?.forEach((item, index) => {
      docs = [
        ...docs,
        {
          id: item.id,
          username: item.username,
          position: item.position,
          date: new Date(item.createdAt).toLocaleDateString("tr-TR"),
          image: item.pfp
            ? `${SERVER_DOMAIN + item.pfp}`
            : "https://cdn.vectorstock.com/i/500p/08/19/gray-photo-placeholder-icon-design-ui-vector-35850819.jpg",
        },
      ];
    });
    setRows(docs);
  }, [data]);

  const deleteSelectedItems = async () => {
    setOpen2(true);
  };

  useEffect(() => {
    async function deleteSelected() {
      if (confirmed2 == true) {
        setDeleteSelected(false);
        try {
          await Promise.all(
            selected.map(async (item) => {
              await fetch(`${API}/${endpoint}/${item}`, {
                headers,
                method: "DELETE",
              });
            })
          );

          const updatedRows = rows.filter((row) => !selected.includes(row.id));
          setRows(updatedRows);
          setSelected([]);
          setSuccess(true);
        } catch (error) {
          console.error("Error deleting items:", error);
        }
      }
    }

    deleteSelected();
  }, [confirmed2]);

  return (
    <div style={{ width: "100%" }}>
      <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
      <ErrorAlert show={fail} setShow={(v) => setFail(v)} />
      <DataGrid
        sx={{ minHeight: 580 }}
        disableColumnSorting
        disableAutosize
        disableColumnFilter
        onRowSelectionModelChange={(v) => {
          setSelected(v);
          if (v.length > 0) {
            setDeleteSelected(true);
          } else {
            setDeleteSelected(false);
          }
        }}
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        pageSizeOptions={[10, 20, 30]}
        checkboxSelection
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            csvOptions: { disableToolbarButton: true },
            printOptions: { disableToolbarButton: true },
          },
        }}
      />
      {deleteSelected && (
        <div onClick={deleteSelectedItems} className="deleteBTN">
          Delete Selected Items
        </div>
      )}
      <ConfirmationModal
        message={"Are you sure you want to delete this item?"}
        open={open}
        setOpen={setOpen}
        setConfirmed={(v) => setConfirmed(v)}
      />
      <ConfirmationModal
        message={"Are you sure you want to delete the selected items?"}
        open={open2}
        setOpen={setOpen2}
        setConfirmed={(v) => setConfirmed2(v)}
      />
      <EditUser
        itemToEdit={item}
        setItemToEdit={setItem}
        refresh={refresh}
        setRefresh={setRefresh}
      />
      <ChangePasswordModal
        open={openChangePassword}
        setRefresh={setRefresh}
        userId={selectedUserId}
        onClose={closeChangePasswordForm}
      />
    </div>
  );
}
